// src/components/common/UserMenuItems.tsx
import { User, Settings, CircleHelp, LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import {
    Button, DropdownMenuGroup, DropdownMenuItem, DropdownMenuSeparator,
} from "@/components/ui";

type UserMenuItemsProps = {
    onLogout: () => void;
    onLoginAsClient: () => void;
};

export default function UserMenuItems({ onLogout, onLoginAsClient }: UserMenuItemsProps) {
    const { t } = useTranslation();

    return (
        <>
            <DropdownMenuGroup>
                <DropdownMenuItem asChild>
                    <button onClick={onLoginAsClient} className="w-full cursor-pointer mt-1">
                        <User className="mr-2 h-4 w-4" strokeWidth={1.5} />
                        <span>{t("header.loginAsClient")}</span>
                    </button>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                    <Link to="/settings/account" className="cursor-pointer">
                        <Settings className="mr-2 h-4 w-4" strokeWidth={1.5} />
                        <span>{t("header.settings")}</span>
                    </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                    <Link to="/content-management/helpdesk" className="cursor-pointer">
                        <CircleHelp className="mr-2 h-4 w-4" strokeWidth={1.5} />
                        <span>{t("header.faq")}</span>
                    </Link>
                </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <div className="p-2">
                <Button variant="destructive" className="w-full" onClick={onLogout}>
                    <span>{t("header.logout")}</span>
                    <LogOut className="ml-2 h-4 w-4" strokeWidth={1.5} />
                </Button>
            </div>
        </>
    );
} 